export default __webpack_public_path__ + "static/header-main-899d98cba43593f6d841c13692db984b.jpg";